// @ts-nocheck
import React, {Fragment, PropsWithChildren} from "react";
import * as C from "../controls"
import * as P from "../program-state"
import * as Rr from "react-router-dom"
import { faTrash, faXmark } from "@fortawesome/free-solid-svg-icons"
import {Emit_main} from "../navigation"
import {custom_audience_t} from "../resource/types"
import {z} from "zod"
import { useNavigate } from 'react-router-dom'
import {add_comma} from "../utils";

const find_custom_audience = (custom_audiences : custom_audience_t[] | undefined, custom_audience_id : string) => {
    return custom_audiences && custom_audiences.find((item) => item.id == custom_audience_id)
}

const Facebook_custom_audience = ({audience} : {audience : custom_audience_t}) => {
    const count_average_audience_size = (data: custom_audience_t) => {
        let lower_bound : number = 0;
        let upper_bound : number = 0;
        if (data.facebook_audience) {
            lower_bound += data.facebook_audience.approximate_count_lower_bound;
            upper_bound += data.facebook_audience.approximate_count_upper_bound;
        }
        return (lower_bound + upper_bound) / 2;
    }

    const audience_size = count_average_audience_size(audience) > 0 ? count_average_audience_size(audience) : "Not available";

    return (
        <div className="tw-mt-3 tw-grid tw-grid-cols-1 lg:tw-grid-cols-[33%,1fr] tw-gap-3">
            <C.Eres_bare_card>
                <C.Eres_headerlg>Facebook custom audience</C.Eres_headerlg>
                <p className="tw-text-sm">The equivalent custom audience on Facebook.</p>
            </C.Eres_bare_card>
            <C.Eres_card>
                <div className="tw-m-3">
                    { audience?.meta__facebook_message &&
                        <>
                            <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                                <p className="tw-font-bold">Error Message:</p>
                                <C.Eres_warning_badge>{audience.meta__facebook_message}</C.Eres_warning_badge>
                            </div>
                            <hr className="tw-mt-2" />
                        </>
                    }
                    { audience?.facebook_audience &&  
                        <>
                            <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                                <p className="tw-font-bold">Delivery status:</p>
                                <p className="tw-text-gray-900">{audience.facebook_audience?.delivery_status?.description}</p>
                            </div>
                            <hr className="tw-mt-2" />
                            <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                                <p className="tw-font-bold">Size:</p>
                                <p className="tw-text-gray-900">{add_comma(audience_size)}</p>
                            </div>
                        </>
                    }
                    { !audience?.facebook_audience && !audience?.meta__facebook_message && <p>Not available</p>}
                </div>
            </C.Eres_card>
        </div>
    )
}

const Linkedin_custom_audience = ({audience} : {audience : custom_audience_t}) => {
    return (
        <div className="tw-mt-3 tw-grid tw-grid-cols-1 lg:tw-grid-cols-[33%,1fr] tw-gap-3">
            <C.Eres_bare_card>
                <C.Eres_headerlg>Linkedin custom audience</C.Eres_headerlg>
                <p className="tw-text-sm">The equivalent custom audience on Linkedin.</p>
            </C.Eres_bare_card>
            <C.Eres_card>
                <div className="tw-m-3">
                    { audience?.meta__linkedin_message && 
                    <>
                        <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                            <p className="tw-font-bold">Error Message:</p>
                            <C.Eres_warning_badge>{audience.meta__linkedin_message}</C.Eres_warning_badge>
                        </div>
                        <hr className="tw-mt-2" />
                    </>
                    }
                    { audience?.linkedin_audience &&
                        <>
                            <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                                <p className="tw-font-bold">Delivery status:</p>
                                <p className="tw-text-gray-900">{audience.linkedin_audience?.destinations[0].status}</p>
                            </div>
                            <hr className="tw-mt-2" />
                            <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                                <p className="tw-font-bold">Size:</p>
                                <p className="tw-text-gray-900">{add_comma(audience?.linkedin_audience?.destinations[0].audienceSize)}</p>
                            </div>
                        </>
                    }
                    { !audience?.linkedin_audience && !audience?.meta__linkedin_message && <p>Not available</p>}
                </div>
            </C.Eres_card>
        </div>
    )
}

const Tiktok_custom_audience = ({audience} : {audience : custom_audience_t}) => {
    return (
        <div className="tw-mt-3 tw-grid tw-grid-cols-1 lg:tw-grid-cols-[33%,1fr] tw-gap-3">
            <C.Eres_bare_card>
                <C.Eres_headerlg>Tiktok custom audience</C.Eres_headerlg>
                <p className="tw-text-sm">The equivalent custom audience on Tiktok.</p>
            </C.Eres_bare_card>
            <C.Eres_card>
                <div className="tw-m-3">
                    { audience?.meta__tiktok_message && 
                    <>
                        <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                            <p className="tw-font-bold">Error Message:</p>
                            <C.Eres_warning_badge>{audience.meta__tiktok_message}</C.Eres_warning_badge>
                        </div>
                        <hr className="tw-mt-2" />
                    </>
                    }
                    { audience?.tiktok_audience && 
                        <>
                            <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                                <p className="tw-font-bold">Is valid:</p>
                                <p className="tw-text-gray-900">{audience?.tiktok_audience?.is_valid ? "Yes" : "No"}</p>
                            </div>
                            <hr className="tw-mt-2" />
                            <div className="tw-mt-2 tw-flex tw-justify-between tw-items-center">
                                <p className="tw-font-bold">Size:</p>
                                <p className="tw-text-gray-900">{add_comma(audience?.tiktok_audience?.cover_num)}</p>
                            </div>
                        </>
                    }
                    { !audience?.tiktok_audience && !audience?.meta__tiktok_message && <p>Not available</p>}
                </div>
            </C.Eres_card>
        </div>
    )
}


const Custom_audience_individual_view = ({audience} : {audience: custom_audience_t}) => {
    const [is_delete_modal_open, set_is_delete_modal_open] = React.useState<bool>(false)
    const nav = useNavigate()
    const [ps, cs] = P.use_authenticated_program_state()
    const is_no_network_information_at_all = (audience : custom_audience_t) => {
        return !audience.facebook_audience && !audience.linkedin_audience && !audience.tiktok_audience && !audience.meta__facebook_message && !audience.meta__linkedin_message && !audience.meta__tiktok_message;
    }

    const delete_the_item = async () => {
        const [ok, resp] = await P.issue_json_delete(P.v1api`audiencesv2/custom-audiences/${audience.id}`, z.any(), cs.token)
        if (ok) {
            nav("/custom-audiences/")
        } else {
            console.log("Delete custom audience failed", resp)
        }
    }

    const button_strip = (
        <div className="tw-flex tw-gap-1.5 tw-items-center tw-flex-row-reverse">
            <C.Eres_iconbutton tabIndex={2} icon={faTrash} onClick={delete_the_item} className="tw-bg-danger-bg hover:tw-bg-danger-hoverbg">Delete</C.Eres_iconbutton>
            <C.Eres_iconbutton tabIndex={1} icon={faXmark} onClick={() => set_is_delete_modal_open(false)}>Cancel</C.Eres_iconbutton>
        </div>
    )

    return (
        <div>
            { is_delete_modal_open &&
            <C.Eres_modal button_strip={button_strip} title={`Are you sure you want to delete ${audience.name}?`} >
                <p>This currently cannot be undone. Are you sure you want to delete {audience.name}.</p>
            </C.Eres_modal>
            }

            <C.Eres_bare_card className="tw-mb-4">
                <div className='tw-flex tw-items-center tw-justify-between'>
                    <C.Eres_header2xl className="tw-font-semibold">Name: {audience.name}</C.Eres_header2xl>
                    <div className='tw-flex-shrink-0'>
                        <C.Eres_iconbutton id="f-save" onClick={() => set_is_delete_modal_open(true)} icon={faTrash} type="submit">Delete</C.Eres_iconbutton>
                    </div>
                </div>
            </C.Eres_bare_card>

            <C.Eres_hline className="tw-my-3" />
            { is_no_network_information_at_all(audience) ?  
                <C.Eres_warning_badge>An unknown problem occurred when creating the custom audience, please try to create another one or contact support for further assistance.</C.Eres_warning_badge> : 
                <div>
                    <Facebook_custom_audience audience={audience} />
                    <C.Eres_hline className="tw-my-3" />
                    <Linkedin_custom_audience audience={audience} />
                    <C.Eres_hline className="tw-my-3" />
                    <Tiktok_custom_audience audience={audience} />
                </div>
        }
        </div>
    )
}


export default function Custom_audience_individual_page() {
    P.run_once_on_component_creation(() => void P.poll_custom_audiences(ps, cs))
    const [custom_audiences, ps, cs] = P.use_custom_audiences()
    const { custom_audience_id } = Rr.useParams()
    const audience = find_custom_audience(custom_audiences, custom_audience_id)

    return (
        <Emit_main page_id="PAGE-custom-audiences">
            { audience ? <Custom_audience_individual_view audience={audience} /> : <p>Loading</p> }
        </Emit_main>
    )
}
